import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import './styles.css';
import AppLogoSVG from '../AppLogoSVG';
import AppNameSVG from '../AppNameSVG';
import ButtonLink from '../ButtonLink';
// import windowsIcon from '../../assets/windows-icon.png';
// import macosIcon from '../../assets/macos-icon.png';
// import linuxIcon from '../../assets/linux-icon.png';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const Navbar = ({ animation, pricingHover, hideNav }) => {
  const navRef = useRef();

  let navClasses = 'text-white p-4';
  if (hideNav) {
    navClasses = 'hidden';
  }

  // if (animation) {
  //   navClasses = 'text-white p-4 animation-show-nav';
  // }

  // useEffect(() => {
  //   window.onload = () => {
  //     document
  //       .querySelector('.button-downloads')
  //       .addEventListener('mouseover', () => {
  //         showDownloads();
  //       });
  //   };
  // }, []);
  const [isExpanded, setIsExpanded] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const timeoutRef = useRef(null);

  const showDownloads = (value) => {
    if (value) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;

      setIsExpanded(true);
    } else {
      timeoutRef.current = setTimeout(() => {
        setIsExpanded(false);
      }, 500);
    }
  };

  useEffect(() => {
    const nav = navRef.current;

    let previousScroll = window.scrollY;
    let scrollDownCount = 0;
    let scrollUpCount = 0;
    let isHidden = false;
    let scrolled = false;

    const trigger = ScrollTrigger.create({
      start: 'top top',
      end: 'bottom bottom',
      onUpdate: (self) => {
        if (isHidden) {
          scrolled = false;
        }
        if (scrolled) {
          return;
        }
        scrolled = true;
        setTimeout(() => {
          scrolled = false;
        }, 100);
        const currentScroll = self.scroll();

        if (currentScroll > previousScroll) {
          scrollDownCount++;
          scrollUpCount = 0;

          if (scrollDownCount >= 4 && !isHidden) {
            gsap.to(nav, { y: -100, duration: 0.3, ease: 'power2.out' });
            setMenuOpen(false);
            isHidden = true;
          }
        } else {
          scrollUpCount++;
          scrollDownCount = 0;

          if (scrollUpCount >= 1 && isHidden) {
            gsap.to(nav, { y: 0, duration: 0.3, ease: 'power2.out' });
            isHidden = false;
          }
        }
        previousScroll = currentScroll;
      },
    });

    return () => {
      trigger.kill();
    };
  }, []);

  return (
    <nav ref={navRef} className={`${navClasses} text-white py-4`}>
      <div className="container mx-auto flex justify-between items-center px-4">
        <Link to="/" className="flex items-center space-x-2">
          <div className="w-8 h-8 flex items-center justify-center">
            <AppLogoSVG
              height="50"
              width="50"
              animation={animation}
              isIcon={true}
            />
          </div>
          <AppNameSVG
            width={170}
            height={35}
            animation={animation}
            isIcon={true}
          />
        </Link>

        <button
          className="lg:hidden text-white"
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-8 h-8"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3.75 7.5h16.5M3.75 12h16.5M3.75 16.5h16.5"
            />
          </svg>
        </button>

        <div
          className={`${
            menuOpen ? 'block' : 'hidden'
          } lg:flex lg:items-center lg:space-x-8 space-y-4 lg:space-y-0 absolute
        lg:static bg-gray-900 lg:bg-transparent top-16 left-0 w-dvw lg:w-auto
         p-4 lg:p-0 `}
        >
          <ul className="flex flex-col lg:flex-row lg:space-x-4 text-left items-end">
            <li>
              <ButtonLink text="Reviews" link="#reviews" />
            </li>
            <li>
              <ButtonLink
                text="Pricing"
                link="/pricing"
                hovered={pricingHover}
              />
            </li>
            <li>
              <ButtonLink text="Features" link="#features" />
            </li>
          </ul>

          <div className="mt-4 lg:mt-0 div-downloads">
            <button
              onMouseOver={() => showDownloads(true)}
              onMouseOut={() => showDownloads(false)}
              className={`button-downloads ${
                isExpanded ? 'button-hover' : ''
              } flex items-center ml-auto`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className={`size-6 inline mr-1 arrow ${
                  isExpanded ? 'arrow-up' : ''
                }`}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m19.5 8.25-7.5 7.5-7.5-7.5"
                />
              </svg>
              Downloads
            </button>

            <div
              className={`div-links-downloads ${
                isExpanded ? 'show-downloads' : ''
              }`}
              onMouseOver={() => showDownloads(true)}
              onMouseOut={() => showDownloads(false)}
            >
              <a className={menuOpen ? 'mx-auto w-max' : ''} href="/">
                <p className="download-name">Coming Soon...</p>
              </a>
              {/* <a className={menuOpen ? 'mx-auto w-max' : ''} href="/">
                <img className="icon-link" src={windowsIcon} alt="" />
                <p className="download-name">Windows</p>
              </a>
              <a className={menuOpen ? 'mx-auto w-max' : ''} href="/">
                <img className="icon-link" src={macosIcon} alt="" />
                <p className="download-name">MacOS</p>
              </a>
              <a className={menuOpen ? 'mx-auto w-max' : ''} href="/">
                <img className="icon-link" src={linuxIcon} alt="" />
                <p className="download-name">Linux .deb</p>
              </a>
              <a className={menuOpen ? 'mx-auto w-max' : ''} href="/">
                <img className="icon-link" src={linuxIcon} alt="" />
                <p className="download-name">Linux .wpm</p>
              </a> */}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
